import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: "优惠政策",
    style: {
      "background-color": "lightblue"
    }
  }), _createElementVNode("div", {
    style: _normalizeStyle([{
      "padding": "0.6rem",
      "text-align": "center",
      "background-color": "aliceblue"
    }, {
      'minHeight': $data.viewhight + 'px'
    }])
  }, [_createElementVNode("div", null, [_cache[1] || (_cache[1] = _createElementVNode("h3", null, "惠民政策公示", -1)), _createElementVNode("img", {
    src: "/img/people.jpg",
    width: "100%",
    height: "auto",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.preview2 && $options.preview2(...args))
  })]), _cache[2] || (_cache[2] = _createStaticVNode("<h3>惠民政策执行说明</h3><p style=\"line-height:normal;text-align:left;\"><strong>可享受惠民项目减免人员：</strong></p><p style=\"line-height:normal;text-align:left;\">1.具有尧都区户籍、死亡后选择火化的居民(包括在异地死亡通体火化的本区户籍居民)；</p><p style=\"line-height:normal;text-align:left;\">2.经县(市、区）以上公安部门出具火化证明的无名尸体;</p><p style=\"line-height:normal;text-align:left;\"><strong>不列入补贴范围人员：</strong></p><p style=\"line-height:normal;text-align:left;\">1.机关、企事业单位职工死亡人员具备享受补助资格的;</p><p style=\"line-height:normal;text-align:left;\">2.火化区范围内死亡火化后将骨灰装棺二次土葬的;</p><p style=\"line-height:normal;text-align:left;\">3.在火化区遗体土葬的;</p>", 8))], 4)]);
}